import { combineReducers } from "redux";

import DocumentListFilterReducer from "@tIntermatic/Store/Components/DocumentListFilter/DocumentListFilterReducer";
import NewsListFilterReducer from "@tIntermatic/Store/Components/NewsListFilter/NewsListFilterReducer";
import RelatedProductReducer from "@tIntermatic/Store/Components/RelatedProductFilter/RelatedProductReducer";

const componentsReducers = {
    newsListFilter: NewsListFilterReducer,
    documentsFilter: DocumentListFilterReducer,
    relatedProductFilter: RelatedProductReducer,
};

export type ComponentsReducers = typeof componentsReducers;

const componentsReducer = combineReducers(componentsReducers as any);

export default componentsReducer;
